import React from 'react'
import { connect } from 'react-redux'
import { initOutputVariable, editVariable, initOutputOption } from '../../redux/actions/output';
import { icSetOption, icSetVariable } from '../../redux/actions/input_context';
import LpHelper from './helper';
import { editedDocument } from '../../redux/actions/account_settings';
import { isDocumentEdited } from '../../globals';
import LpWarning from './warning';
import { lpGetOptionById, lpGetVariableById } from '../../logic/re_index';
import lpApp from '../../app/lp_app';
import InputMask from 'react-input-mask';
import { generateId1 } from '../utils/misc';

class BasicMask extends React.Component {
  constructor(props) {
    super(props);
    this.params = {
      ...props,
    };
    this.lpKey = generateId1(4);
    this.onValueChanged = this.onValueChanged.bind(this);
    this.onBlur = this.onBlur.bind(this);
    if (props.isDuplicate) 
      this.params.id = `${this.params.id}_${props.copy}`;
  }


  componentWillMount() {
    if (!this.props.exists) {
      this.props.initializeOutput(this.props.isDuplicate ? `${this.props.id}_${this.props.copy}` : this.props.id, this.props.lpKey, this.props.ovc, lpApp.indexes.variables.getVariable(this.props.isDuplicate ? `${this.props.id}_${this.props.copy}` : this.props.id).value);
    } else {
      this.params.label = lpApp.references.getOption(this.props.id);
    }
  }


  onValueChanged(val) {
    this.props.editOutput(this.props.isDuplicate ? `${this.props.id}_${this.props.copy}` : this.params.id, val);
  }

  onBlur() {
    this.props.unUpdateContext;
  }

  render() {
    // Variable ref
    let variable_ref = lpApp.references.getVariable(this.props.id);

    // Placeholder
    let placeholder = (variable_ref && variable_ref.placeholder) ? variable_ref.placeholder : "";

    // Mask
    let mask = (variable_ref && variable_ref.mask) ? variable_ref.mask : "";
    
    return (
      <div className="form-group">
        <label htmlFor={this.props.lpKey}>
        { this.props.label }
        {' '}
        {'helper' in lpApp.references.getVariable(this.props.id) && lpApp.references.getVariable(this.props.id).helper.length > 0 && <LpHelper text={lpApp.references.getVariable(this.props.id).helper} />}
        </label>
        {(this.props.id in lpApp.references.variables) && lpApp.references.getVariable(this.props.id).warning && <LpWarning text={lpApp.references.getVariable(this.props.id).warning} id={this.props.id} type="v" />}
        <div className="fc-container">
          <InputMask 
          name={generateId1(1)}
          placeholder={placeholder}
          id={this.props.lpKey}
          value={this.props.value}
          autoComplete={this.props.autocomplete}
          onChange={evt => this.onValueChanged(evt.target.value)}
          onBlur={this.onBlur}
          className="form-control"
          mask={mask} 
          placeholder={placeholder} />
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state, ownProps) => {
  // test if exists
  let exists = false;
  let existantKey = '';
  const existantParent = '';
  let value = '';
  const realId = ownProps.isDuplicate ? `${ownProps.id}_${ownProps.copy}` : ownProps.id;

  if (ownProps.ovc === 'o') {
    if (typeof lpGetOptionById(realId) !== 'undefined') {
      exists = true;
      existantKey = lpGetOptionById(realId).key;
      ({ value } = lpGetOptionById(realId));
    }
  }
  if (ownProps.ovc === 'v') {
    if (typeof lpGetVariableById(realId) !== 'undefined') {
      exists = true;
      existantKey = lpGetVariableById(realId).key;
      ({ value } = lpGetVariableById(realId));
    }
  }
  
  let isShown = false;
  if ((state.input_context.variable !== '') && (state.input_context.variable === ownProps.id)) {
    isShown = true;
  }
  const hw = lpApp.indexes.var_to_view.getViewByVar(ownProps.id);
  return {
    had_output: hw ? hw.length > 0 : false,
    sectionId: state.contract.currentSection,
    exists,
    existant_key: existantKey,
    existant_parent: existantParent,
    value,
    show_popup: isShown,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  // this case, parent = key
  initializeOutput: (id, parent, genre, value = '') => {
    if (genre === 'o') dispatch(initOutputOption(id, parent, value));
    else if (genre === 'v') dispatch(initOutputVariable(id, parent, value));
  },
  editOutput: (id, val) => {
    if (ownProps.ovc === 'o') {
      dispatch(editOption(id, val));
    } else {
      dispatch(editVariable(id, val));
    }
    if (!isDocumentEdited()) dispatch(editedDocument(true));
  },
  updateContext: () => {
    const cId = ownProps.isDuplicate ? `${ownProps.id}_${ownProps.copy}` : ownProps.id;
    const pId = ownProps.isDuplicate ? `${ownProps.parent}_${ownProps.copy}` : ownProps.parent;
    if (ownProps.ovc === 'o') dispatch(icSetOption(cId));
    else {
      dispatch(icSetVariable(cId));
      dispatch(icSetOption(pId));
    }
  },
  unUpdateContext: () => {
    if (ownProps.ovc === 'o') dispatch(icSetOption(''));
    else {
      dispatch(icSetVariable(''));
      dispatch(icSetOption(''));
    }
  },
});

const LpBasicMask = connect(mapStateToProps, mapDispatchToProps)(BasicMask);

export default LpBasicMask;



// WEBPACK FOOTER //
// ./src/components/misc/basic_mask.js